import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// let pxString = window.getComputedStyle(document.documentElement)["fontSize"];
// let kJson = {remPx : pxString.substring(0,pxString.length - 2)};
var state = sessionStorage.getItem('state') ? Object.assign(JSON.parse(sessionStorage.getItem('state'))) : {};
/**
 * 	  lang: state1.lang,		//简体 繁体 English
	  length: state1.length,
	  loglevel:state1.loglevel,
	  menuList: state1.menuList,//菜單
 */
console.log(state)
export default new Vuex.Store({
  state: state,
  mutations: {
    adminlogin (state,data) {//用户登录信息
      state.token = data.token;
      state.roles = data.roles;
      state.loginName = data.loginName;
      state.realname = data.realname;
      state.headpic = data.headpic;
      state.position = data.position;
      let rolesArr = data.roles;
      let useArr = [];
	  let arr = []
      rolesArr.forEach((ele) => {
        let bol = true;
		arr.push(ele.role)
        useArr.forEach((els) => {
          if(ele.type == els){
            bol = false;
          }
        });
        if(bol){
          useArr.push(ele.type);
        }
      });
	  state.rolesdata = arr
      state.useArr = useArr;
    },
	//显示 菜单
	handtitle(state,data){
		console.log(data.title)
		state.title = data.title
	},
	//刷新默认菜单
	startpage(state,data){
    console.log(state);
		console.log(data)
		//一级菜单展开项
		state.openKeys = data[1]
		//二级菜单选中项
		state.keyIndex = data[0]
	},
  },
  actions: {

  },
  modules: {

  }
})


